import { isEventEnter, isEventSpace } from './eventHelpers';

export const keyDownHelper = async (e: React.KeyboardEvent<HTMLElement>, callback: (e: React.KeyboardEvent) => void) => {
    if (isEventEnter(e) || isEventSpace(e)) {
        e.preventDefault();
        callback?.(e);
    }
};
